
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class SecurityRepairStatusEditor extends Serenity.Select2Editor<any, any> {

        constructor(element: JQuery) {
            super(element);

            for (var x of [
                "DATAMART: NOT_READY",
                "FAILED: ACCOUNT_HOLDING",
                "FAILED: FACT_ACCOUNT_HOLDING",
                "FAILED: SECURITY_VALUE",
                "FAILED: FACT_SECURITY_VALUE",
                "ODS: NOT_READY",
                "PENDING",
                "SUCCEEDED"])
                this.addOption(x, x);
        }
    }
}